import { SnackbarVariant, useSnackbar } from '@focaldata/cin-ui-components'
import { useEffect, useRef, useState } from 'react'
import {
  isKpiLockDraftUnreadable,
  isKpiLockUnavailable,
  isKpiSubjectLocked
} from '../../Questionnaire/Kpi/kpiErrorMessage'

export const saveFailureMessage = (label: string, error: unknown) =>
  `Failed to save "${label}" — ${
    error instanceof Error ? error.message : 'unexpected error'
  }.`

const isExplainedByWaveLock = (error: unknown) =>
  isKpiSubjectLocked(error) ||
  isKpiLockUnavailable(error) ||
  isKpiLockDraftUnreadable(error)

export const useFieldDraft = (
  field: { label: string; getCurrent: (languageCode: string) => string },
  targetLanguage: string,
  onSave: (text: string) => Promise<unknown> | undefined
) => {
  const { enqueueSnackbar } = useSnackbar()
  const stored = field.getCurrent(targetLanguage)
  const [draft, setDraft] = useState<string>(stored)
  const latestStored = useRef(stored)
  const mounted = useRef(false)

  useEffect(() => {
    latestStored.current = stored
    setDraft(stored)
  }, [stored, targetLanguage])

  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
    }
  }, [])

  const persist = () => {
    if (draft === stored) return
    const sent = draft
    onSave(sent)?.catch((error: unknown) => {
      if (!isExplainedByWaveLock(error)) {
        enqueueSnackbar(saveFailureMessage(field.label, error), {
          variant: SnackbarVariant.Error
        })
      }
      if (mounted.current) {
        setDraft((shown) => (shown === sent ? latestStored.current : shown))
      }
    })
  }

  return { draft, setDraft, persist }
}
